import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS } from './../../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import HeaderLayout from "./../../Layout/Header";
import API from './../../Api';
import { toast } from 'react-toastify';
import Loader from "../../Elements/Loader";
import { ROUTE_VIDEO_INFO_PAGE,RouteChanged,ROUTE_VIDEO_PAGE} from '../../RouteConstents';

const VideoList = () => { 

    const navigate = useNavigate();

    const [records, setRecords] = useState([]); 
    const [isLoading, setIsLoading] = useState(false);
    const [videoURL, setVideoURL] = useState('');
    const [videoTitle, setVideoTitle] = useState('');


    
    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');

        LoadVideoList()
        
    },[true]); 

    const LoadVideoList = async () => {

        let objValue =  {"method_name":"videoList","page":1,"course_id":99,"subject_id":6,"video_title":videoTitle}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status == "success") {
                    setRecords(response.data.videoList);
                    setVideoURL(response.data.video_url); 
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const SearchVideoList = () => {
        LoadVideoList()   
    }

    const ResetVideoList = () => {
        LoadVideoList()  
         
    }


    
    return (
        <>
        <HeaderLayout />
        
        <section className="content">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>Knowledge Section</h2>
                </div> 

                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div id="mws-themer-toggle">
                            <i className="icon-bended-arrow-left"></i> 
                            <i className="icon-bended-arrow-right"></i>
                        </div>
                        <div className="panel-group" id="panel-group-id" role="tablist" aria-multiselectable="true">
                            <div className="panel panel-col-red ">
                                <div className="panel-heading" role="tab" id="panel-heading-id">
                                <h4 className="panel-title">
                                    <a role="button" data-toggle="collapse" data-target="#panel-collapse-id" data-parent="#panel-group-id" href="#" aria-expanded="true" aria-controls="panel-collapse-id" className="collapsed">
                                    <i className="material-icons">search</i> Search
                                    <span className="pull-right collapse-toggle-icon"></span>
                                    <span> (Click here to expand)</span>
                                    </a>
                                </h4>
                                </div>
                                <div id="panel-collapse-id" className="panel-collapse collapse" role="tabpanel" aria-labelledby="panel-heading-id" aria-expanded="true">
                                <div className="panel-body">
                                    <div className="row clearfix ">
                                        <div className="col-xs-12 col-sm-6 col-md-4 col-lg-6">
                                            <div className="form-group">
                                            <div className="form-line">
                                                <input className="form-control" placeholder="Search By Title" name="videoTitle" type="text" onChange={(e) => setVideoTitle(e.target.value)} />
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row clearfix ">
                                        <div className="col-xs-12 col-sm-6 col-md-4 pull-right set_button">
                                            <button type="button" className="btn bg-pink btn-sm waves-effect btn-submit text-decoration-none mr-5" onClick={SearchVideoList} ><i className="material-icons font-14">search</i>Search</button>
                                            <button type="button" onClick={ResetVideoList} className="btn bg-blue-grey text-decoration-none  waves-effect btn-sm mr-5"><i className="material-icons font-14">refresh</i>Reset</button>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">
                
                {
                    records.length > 0 ? (
                    records.map((item, index) => (

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={index}>
                        <div className="card">
                            <div className="header">
                                <h2>
                                    {item.video_title}
                                </h2>
                            </div>
                            <div className="body text-center">
                                <Link to={RouteChanged(ROUTE_VIDEO_INFO_PAGE,item.id)}>
                                    <img src={videoURL+item.thumbnail_image} className="img-responsive" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    ))
                    ) : (
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 text-center">
                            {isLoading ? (
                                <Loader />
                            ) : (
                                'Record Not Found'
                            )}
                        </div>
                    )    
                }
                </div>
            </div>
        </section>
        </>
    );
   
}
    
export default VideoList;